<template>
    <div>
        <section id="f-cli-head1" class="section">



        </section>
        <section id="f-cli-head2" class="section">

            <div class="container">




                <div class="columns">
                    <div class="column is-half" style="text-align:center;">
                        <img src="/static/images/clients/computer.png" alt="Escolha bem...">
                    </div>

                    <div class="column is-half">

                        <h1>Escolha bem...</h1>

                        <p>É facílimo encontrar o profissional ou a proposta ideal para o precisa. Diga-nos o que precisa e nós apresentaremos os melhores profissionais. Depois, só tem que comparar e escolher o profissional certo para si.</p>



                    </div>
                </div>



                <div class="columns">

                    <div class="column is-3 is-hidden-tablet" style="text-align:center;">
                        <img src="/static/images/clients/Tlm.png" alt="Diga-nos o que precisa">
                    </div>
                    <div class="column is-9">


                        <h2>1. Diga-nos o que precisa</h2>


                        <p>
                            Responda a um breve questionário para que possamos saber o que procura. Iremos apresentar o seu pedido a inúmeros Profissionais experientes.
                        </p>


                    </div>
                    <div class="column is-3 is-hidden-mobile" style="text-align:center;">
                        <img src="/static/images/clients/Tlm.png" alt="Diga-nos o que precisa">
                    </div>
                </div>



                <div class="columns">
                    <div class="column is-3" style="text-align:center;">
                        <img src="/static/images/clients/Lupa.png" alt="Receba as propostas">
                    </div>
                    <div class="column is-9">

                        <h2>
                            2. Receba as propostas
                        </h2>

                        <p>
                            Irá receber até 5 propostas por Profissionais interessados no seu pedido e que têm disponibilidade e interesse em prestar-lhe o seu melhor serviço e/ou preço.
                        </p>

                        <p style="margin-top:1rem;">
                            Cada proposta vem com a seguinte informação:
                        </p>

                        <ul>
                            <li><i class="fa fa-arrow-circle-right"></i>&nbsp;Possibilidade de iniciar <em>chat</em> com o Profissional</li>
                            <li><i class="fa fa-arrow-circle-right"></i>&nbsp;Contacto do Profissional</li>
                            <li><i class="fa fa-arrow-circle-right"></i>&nbsp;Mensagem personalizada</li>
                            <li><i class="fa fa-arrow-circle-right"></i>&nbsp;Perfil do Profissional</li>
                        </ul>




                    </div>
                </div>



                <div class="columns">
                    <div class="column is-3 is-hidden-tablet" style="text-align:center;">
                        <img src="/static/images/clients/escolhido.png" alt="Escolha o profissional">
                    </div>
                    <div class="column is-9">
                        <h2>
                           3. Escolha o Profissional
                        </h2>

                        <p>
                            Depois de comparar as propostas recebidas, está à vontade para escolher o profissional com a melhor opção para si. Clique no botão "Aceitar Proposta" e o Profissional saberá que foi o escolhido!
                            <em>Não é fácil, é facílimo.</em>
                        </p>

                    </div>
                    <div class="column is-3 is-hidden-mobile" style="text-align:center;">
                        <img src="/static/images/clients/escolhido.png" alt="Escolha o profissional">
                    </div>
                </div>


            </div>



        </section>

        <div style="margin: 2rem 0 6rem">
            <app-feat-services :cards="cards[i]" :title="title[i]" @setParentService="service = $event" @openOrderModal="orderModal = true"></app-feat-services>
        </div>

        <app-modal-order :helpers="helpers" :orderModal="orderModal" @closeOrderModal="orderModal = null" :service="service"></app-modal-order>


    </div>

</template>

<script>
import AppFeatServices from "../components/FeatServices";
import AppModalOrder from "../components/ModalOrder";

import { all } from "../plugins/serviceList";
import helpers from "../plugins/helpers";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
  components: { AppFeatServices, AppModalOrder },
	mixins: [scrollTop],

	data() {
    return {
      helpers,
      services: all,

      service: null,
      orderModal: false,

      i: 0,
      title: [
        "PROJETOS POPULARES",
        "OBRAS EM CASA",
        "ENCONTRE SOLUÇÕES PARA A SUA EMPRESA"
      ],
      cards: [
        [
          {
            image: "/static/images/feat_services/1.png",
            title: "Comprar moradia",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/2.png",
            title: "Vender apartamento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/3.png",
            title: "Certificação energética",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/4.png",
            title: "Arrendamento apartamento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/5.png",
            title: "Arquitetura",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/6.png",
            title: "Pintura de interiores",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/7.png",
            title: "Instalação de pavimento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/8.png",
            title: "Design de interiores",
            link: "",
            service: 24
          }
        ],
        [
          {
            image: "/static/images/feat_services/canalizacoes.png",
            title: "Canalizações",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/carpintaria.png",
            title: "Carpintaria",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/construcaocivil.png",
            title: "Construção Civil",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/instalacaopainelsolar.png",
            title: "Instalação de Painel Solar",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/limpeza.png",
            title: "Limpeza Geral",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/pavimentoflutuante.png",
            title: "Instalação de Pavimento Flutuante",
            link: "",
            service: 24
          }
        ],
        [
          {
            image: "/static/images/feat_services/advogados.png",
            title: "Advogados",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/contabilidade.png",
            title: "Contabilidade",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/designgrafico.png",
            title: "Design Gráfico",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/seguros.png",
            title: "Agentes e Mediadores de Seguros",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/solicitadoria.png",
            title: "Solicitadoria",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/traducao.png",
            title: "Tradução",
            link: "",
            service: 24
          }
        ]
      ]
    };
  },
  mounted() {
    this.i = Math.floor(Math.random() * 3 + 1);
    this.cards[this.i] = helpers.shuffle(this.cards[this.i]);
  }
};
</script>
<style scoped>
h1 {
  font-weight: 500;
  font-size: 2.3rem;
  line-height: 1.15;
  color: #2d3256;
  margin-bottom: 1.5rem;
  padding: 0 2rem;
}

h2 {
  font-weight: 500;
  font-size: 2rem;
  line-height: 1.15;
  color: #2d3256;
  margin-bottom: 1rem;
  padding: 0 2rem;
}

p {
  color: black;
  font-size: 1.2rem;
  line-height: 1.2;
  text-align: justify;
  padding: 0 2rem;
}

ul {
  padding: 0.5rem 2rem;
}

li {
  color: black;
  font-size: 1.2rem;
  line-height: 1.2;
}

i {
  color: #2d3256;
  margin-right: 1rem;
}

.columns {
  margin: 4rem 0;
}

.columns:last-child {
  margin: 4rem 0 1rem;
}

#f-cli-head1 {
  background-image: url("/static/images/clients/banner.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 20rem;
}

#f-cli-head2 {
  border-top: solid 8px #e90054;
  background-color: #ffffff;
  color: white;
}

@media screen and (min-width: 1216px) {
  .container {
    padding: 1rem 6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Clients.vue